/* HONEY MONEY · carrito real (P23): Cart API AJAX de Shopify (/cart/add.js, /cart/change.js) + Section Rendering API (sección hm-cart-drawer).
   Añadir desde la ficha (formulario real), desde la tarjeta (+) y desde la hoja de tallas; cambiar cantidad, talla y quitar (con deshacer) en el cajón.
   La pantalla nunca inventa el carrito: después de cada cambio pinta lo que devuelve Shopify. "Finalizar compra" = /checkout de Shopify. */
(() => {
const boot = () => {
const HM = window.HM; if (!HM || !document.getElementById('hm-drawer') || HM.cart) return;
const {$, $$, S, RM} = HM;
const CFG = window.hmCfg || {};
const SECTION = 'hm-cart-drawer,hm-cart-page'; // el cajón y la página /cart se repintan juntos con lo que devuelve Shopify
const url = (base, fallback) => (base || fallback) + '.js';
const ADD = url(CFG.cartAdd, '/cart/add'), CHANGE = url(CFG.cartChange, '/cart/change');
const drawer = $('#hm-drawer');
const fill = (tpl, k, v) => String(tpl || '').replace(k, v);

/* pinta el cajón y la página /cart con el HTML que devuelve Shopify y mueve el contador de la bolsa */
const paintOne = (html, rootId, fallbackSel) => {
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html'), fresh = $('#' + rootId, doc), old = $('#' + rootId);
  if (!fresh || !old) return;
  const hadFocus = old.contains(document.activeElement) ? document.activeElement : null;
  const focusSel = hadFocus && (hadFocus.dataset.act ? `#${rootId} [data-key="${hadFocus.closest('[data-key]')?.dataset.key}"] [data-act="${hadFocus.dataset.act}"]` : null);
  old.replaceWith(document.adoptNode(fresh));
  setCount(+fresh.dataset.count || 0);
  if (hadFocus) { const f = (focusSel && $(focusSel)) || $(fallbackSel); if (f) f.focus({preventScroll: true}); }
};
const paint = html => paintOne(html, 'hm-drawer-in', '.hm-drawer__h button');
const paintAll = secs => { if (!secs) return; paint(secs['hm-cart-drawer']); paintOne(secs['hm-cart-page'], 'hm-cartpage-in', '.hm-cartpage .hm-qs__more'); };
const setCount = n => {
  const b = $('#hm-count'); if (!b) return;
  const sp = b.firstElementChild, old = sp.textContent.trim();
  if (String(n) !== old) { b.dataset.prev = old; sp.textContent = n; }
  b.classList.toggle('has', n > 0);
  const btn = $('#hm-cart-btn'); if (btn) btn.setAttribute('aria-label', (btn.dataset.label || '') + (n ? ', ' + n : ''));
};
const bump = () => { const b = $('#hm-cart-btn'); if (!b) return; b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); };

/* errores de Shopify (422): sin stock o tope de unidades = "Ya tienes todas las que quedan"; lo demás, aviso genérico */
const why = async r => { let j = {}; try { j = await r.json(); } catch (e) {} return j; };
const tellError = j => HM.toast(/sold out|agotad|only|solo|disponible|available|inventory|stock/i.test((j.description || '') + ' ' + (j.message || '')) ? S('max') : S('error'));

const post = async (u, body) => {
  const isForm = body instanceof FormData;
  const r = await fetch(u, {method: 'POST', headers: isForm ? {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'} : {'Content-Type': 'application/json', Accept: 'application/json'}, body: isForm ? body : JSON.stringify(body)});
  return r;
};

/* añadir: devuelve true si Shopify lo aceptó */
const add = async (payload, title) => {
  let r;
  try { r = await post(ADD, payload); } catch (e) { HM.toast(S('error')); return false; }
  if (!r.ok) { tellError(await why(r)); return false; }
  const j = await r.json(); paintAll(j.sections); bump();
  if (title) HM.say(fill(S('added'), '[producto]', title));
  return true;
};
const addOne = (id, quantity = 1, title) => add({items: [{id: +id, quantity}], sections: SECTION}, title);
const change = async (key, quantity) => {
  const hosts = [drawer, $('.hm-cartpage')].filter(Boolean); hosts.forEach(x => x.classList.add('busy'));
  let ok = false;
  try { const r = await post(CHANGE, {id: key, quantity, sections: SECTION}); if (r.ok) { const j = await r.json(); paintAll(j.sections); ok = true; } else tellError(await why(r)); }
  catch (e) { HM.toast(S('error')); }
  hosts.forEach(x => x.classList.remove('busy'));
  return ok;
};
HM.cart = {add, addOne, change, paint, paintAll};

/* abrir el cajón con la bolsa (sin JavaScript, el enlace lleva a /cart) */
document.addEventListener('click', e => { const c = e.target.closest('[data-hm-cart]'); if (!c) return; e.preventDefault(); $('#hm-toast').classList.remove('on'); if ($('.hm-cartpage')) { scrollTo({top: 0, behavior: RM.matches ? 'auto' : 'smooth'}); return; } HM.open(drawer); }); // en /cart la bolsa ya es esta página

/* ficha: el formulario real se manda por AJAX; si falta talla, avisa y no manda nada */
let drawerT = 0;
const pdpSubmit = async (form, src) => {
  if (HM.pdpNeedSize && HM.pdpNeedSize()) return;
  const fd = new FormData(form); fd.append('sections', SECTION);
  const title = ($('#hm-pdp h1') || {}).textContent || '';
  src = src || $('[data-t="add"]', form);
  if (src) src.setAttribute('aria-busy', 'true');
  const ok = await add(fd, title);
  if (src) src.removeAttribute('aria-busy');
  if (!ok) return;
  $('#hm-toast').classList.remove('on'); HM.celebrate(src);
  clearTimeout(drawerT); drawerT = setTimeout(() => { if (!HM.layerEl()) HM.open(drawer); }, RM.matches ? 234 : 585); // el cajón se abre DESPUÉS de la celebración
};
document.addEventListener('submit', e => { const f = e.target.closest('#hm-pform'); if (!f) return; e.preventDefault(); pdpSubmit(f, e.submitter); });

document.addEventListener('click', async e => {
  /* barra fija del móvil: con tallas y sin elegir, abre la hoja; si no, añade como el botón grande */
  const sadd = e.target.closest('[data-act="sadd"]');
  if (sadd) {
    const box = $('#hm-pdp'), vid = $('#hm-vid');
    if (box.dataset.sized === 'true' && !vid.value) { const vars = JSON.parse(box.dataset.vars || '[]'); HM.openSheet({dataset: {vars: JSON.stringify(vars), title: $('h1', box).textContent, price: ($('#hm-price') || {}).textContent || '', url: location.pathname}}, 'pdp'); }
    else pdpSubmit($('#hm-pform'), sadd);
    return;
  }
  /* compra dentro de la tarjeta ("Su merch" y filas): elegir talla y Añadir; sin talla elegida, la tarjeta tiembla y el botón pide la talla */
  const ls = e.target.closest('[data-act="lsize"]');
  if (ls) {
    if (ls.getAttribute('aria-disabled') === 'true') return;
    const lb = ls.closest('.hm-lbuy'); $$('[data-act="lsize"]', lb).forEach(x => x.setAttribute('aria-pressed', String(x === ls))); lb.dataset.v = ls.dataset.v;
    const ab = $('[data-act="ladd"]', lb); if (ab && !ab._orig) ab.textContent = ab.dataset.label;
    return;
  }
  const la = e.target.closest('[data-act="ladd"]');
  if (la) {
    const lb = la.closest('.hm-lbuy'), sized = !!$('.hm-sizes:not(.hm-sizes--one)', lb);
    if (sized && !lb.dataset.v) { lb.classList.remove('shake'); void lb.offsetWidth; lb.classList.add('shake'); la.textContent = la.dataset.need; return; }
    const vid = lb.dataset.v || la.dataset.v1, size = (lb.querySelector('[aria-pressed="true"]') || {dataset: {}}).dataset.size;
    if (await addOne(vid, 1, la.dataset.title)) {
      HM.toast(fill(S('added'), '[producto]', la.dataset.title + (size ? ' · ' + size : ''))); HM.celebrate(la);
      $$('[data-act="lsize"]', lb).forEach(x => x.setAttribute('aria-pressed', 'false')); delete lb.dataset.v;
    }
    return;
  }
  /* + de la tarjeta: sin tallas, directo; con tallas, la hoja */
  const q = e.target.closest('[data-act="quick"]');
  if (q) {
    if (q.dataset.sized === 'true') return HM.openSheet(q, 'grid');
    const v = JSON.parse(q.dataset.vars || '[]')[0]; if (!v) return;
    if (await addOne(v.id, 1, q.dataset.title)) { HM.toast(fill(S('added'), '[producto]', q.dataset.title)); HM.celebrate(q); }
    return;
  }
  /* hoja de tallas: celebra, cierra y avisa; desde la ficha abre el cajón */
  const pick = e.target.closest('[data-act="pick"]');
  if (pick) {
    if (pick.getAttribute('aria-disabled') === 'true') return;
    const qs = pick.closest('.hm-qs'), ctx = qs.dataset.ctx, title = $('h2', qs).textContent;
    if (ctx === 'pdp' && HM.pdpSelect) HM.pdpSelect(pick.dataset.v);
    const body = $('#hm-sheet-body'); body.style.pointerEvents = 'none';
    const ok = await addOne(pick.dataset.v, 1, title + ' · ' + pick.dataset.size);
    if (!ok) { body.style.pointerEvents = ''; HM.closeAll(); return; }
    HM.celebrate(pick);
    setTimeout(() => { body.style.pointerEvents = ''; HM.closeAll(); if (ctx === 'pdp') HM.open(drawer); else HM.toast(fill(S('added'), '[producto]', title + ' · ' + pick.dataset.size)); }, RM.matches ? 260 : 845);
    return;
  }
  /* cajón: menos, más, quitar (con deshacer) */
  const b = e.target.closest('#hm-drawer [data-act], .hm-cartpage [data-act]'); if (!b) return;
  const line = b.closest('[data-key]'); if (!line) return;
  const key = line.dataset.key, qn = +line.dataset.q;
  if (b.dataset.act === 'inc') change(key, qn + 1);
  if (b.dataset.act === 'dec') change(key, qn - 1);
  if (b.dataset.act === 'rm') {
    const gone = {v: line.dataset.v, q: qn, title: $('h5', line).textContent};
    if (await change(key, 0)) HM.toast(fill(S('removed'), '[producto]', gone.title), {label: S('undo'), fn: () => addOne(gone.v, gone.q)});
  }
});
/* cambiar de talla en el cajón: quita la línea y añade la otra talla con la misma cantidad (Shopify junta las iguales) */
document.addEventListener('change', async e => {
  const sel = e.target.closest('#hm-drawer [data-t="lsz"], .hm-cartpage [data-t="lsz"]'); if (!sel) return;
  const line = sel.closest('[data-key]'), q = +line.dataset.q, to = sel.value;
  if (await change(line.dataset.key, 0)) await addOne(to, q);
});
/* volver con la flecha del navegador a una página guardada en memoria: el carrito puede haber cambiado en otra pestaña */
addEventListener('pageshow', async e => {
  if (!e.persisted) return;
  try { const r = await fetch((CFG.root || '/') + '?sections=' + SECTION); if (r.ok) paintAll(await r.json()); } catch (err) {}
});
};
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
